module.exports = "/_next/static/images/teacher-9-2c455a6d1b8e5bb9c849cf3632f6acc8.png";